import React, { ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { InlineMessageType } from './types';
import { IconInfoCircle } from '../icons';
export const InlineMessage = ({
  message,
  type,
  showIcon = true,
  className = ''
}: InlineMessageType) => {
  const icons: Record<InlineMessageType['type'], ReactNode> = {
    guideline: <IconInfoCircle className='h-4 w-4 shrink-0 text-alert-warning-dark' />,
    error: <IconInfoCircle className='h-4 w-4 shrink-0 text-alert-error-dark' />,
    success: <IconInfoCircle className='h-4 w-4 shrink-0 text-alert-success-dark' />,
    counter: null
  };
  return <div className={cn('flex gap-1 [&>svg]:mt-0.5', className)} data-sentry-component="InlineMessage" data-sentry-source-file="inline-message.tsx">
            {showIcon && icons[type]}

            <span className={cn('text-caption-12', {
      'text-alert-error-dark': type === 'error',
      'text-text-darkGray': type !== 'error',
      'mr-auto': type === 'counter'
    })}>
                {message}
            </span>
        </div>;
};